import createReducer from "utils/createReducer";
import { fromJS } from "immutable";
import { isEmpty } from "lodash";
import { CategoryTypes } from "actions/types";
import * as queryString from "query-string";

export const defaultValue = fromJS({});

export const filters = createReducer(defaultValue, {
  [CategoryTypes.FILTER_SEARCH](state, { payload }) {
    let filters = state.getIn([payload.category, "data", "filters"]);
    let subCategoryIndex = filters.findIndex((filter) => {
      return filter.get("id") === payload.subCategory;
    });

    let newState = state.setIn(
      [payload.category, "data", "filters", subCategoryIndex, "search"],
      payload.value,
    );

    return newState;
  },
  [CategoryTypes.FETCH_FILTERS](state, { payload }) {
    let newState = state;
    newState = newState.setIn(
      [payload.route.get("rel"), "route"],
      fromJS(payload.route),
    );
    newState = newState.setIn([payload.route.get("rel"), "isLoading"], true);
    return newState;
  },
  [CategoryTypes.SET_FILTERS](state, { payload }) {
    let imPayload = fromJS(payload);
    let mergePayload = fromJS(payload);
    let filtersId = payload.route.get("rel");
    let { query } = queryString.parseUrl(payload.route.get("href"));

    imPayload.getIn(["data", "filters"]).forEach((filter, filterKey) => {
      let enabledCount = 0;
      let toggledCount = 0;
      let filterId = filter.get("id");
      let search;

      try {
        search = state.getIn([
          filtersId,
          "data",
          "filters",
          filterKey,
          "search",
        ]);

        if (search) {
          mergePayload = mergePayload.setIn(
            ["data", "filters", filterKey, "search"],
            search,
          );
        }
      } catch (err) {}

      filter.get("values").forEach((value, key) => {
        let newValue = state.getIn([
          payload.route.get("rel"),
          "data",
          "enabledFilters",
          filterKey,
          value.get("id"),
        ])
          ? state.getIn([
              payload.route.get("rel"),
              "data",
              "enabledFilters",
              filterKey,
              value.get("id"),
            ])
          : value;

        let hasToggleKey = Object.keys(query).includes(filterId);
        let hasToggled = Object.values(query).includes(value.get("id"));

        if (hasToggled && hasToggleKey) {
          newValue = newValue.setIn(["toggled"], true);
        }

        mergePayload = mergePayload.setIn(
          ["data", "filters", filterKey, "values", key],
          newValue,
        );

        if (newValue.get("enabled")) {
          enabledCount++;
        }
        if (newValue.get("toggled")) {
          toggledCount++;
        }
      });
      mergePayload = mergePayload.setIn(
        ["data", "filters", filterKey, "visible"],
        enabledCount > 1,
      );
      mergePayload = mergePayload.setIn(
        ["data", "filters", filterKey, "enabledCount"],
        enabledCount,
      );
      mergePayload = mergePayload.setIn(
        ["data", "filters", filterKey, "toggledCount"],
        toggledCount,
      );
    });
    let newState;
    if (isEmpty(state.getIn([payload.route.get("rel"), "data", "filters"]))) {
      newState = state.mergeDeepIn([payload.route.get("rel")], mergePayload);
      let defaultSort;
      try {
        defaultSort = imPayload
          .getIn(["data", "sorts"])
          .find((sort) => {
            return sort.get("isDefault") === true;
          })
          .get("id");
      } catch (err) {}
      newState = newState.setIn(
        [payload.route.get("rel"), "data", "sortBy"],
        defaultSort ? defaultSort : imPayload.getIn(["data", "sorts", 0, "id"]),
      );
    } else {
      newState = state.setIn(
        [payload.route.get("rel"), "data", "filters"],
        mergePayload.getIn(["data", "filters"]),
      );
    }
    newState = newState.setIn([payload.route.get("rel"), "isLoading"], false);
    return newState;
  },
  [CategoryTypes.TOGGLE_FILTER](state, { payload }) {
    // `payload.filter` arrives as a real Immutable Map from CategoryGameTypeFilterComponent
    // (still-class consumer, passes its own `value.original` straight through) but as a plain
    // object from ShowMoreFilterComponent (converted PLAY-5152, its FilterValue type is plain
    // per store/selectors/filters.ts's "never leak Immutable" boundary) - normalize once here
    // rather than require every call site to agree on a shape.
    let payloadFilter =
      payload.filter && typeof payload.filter.get === "function"
        ? payload.filter
        : fromJS(payload.filter);
    let filters = state.getIn([payload.category, "data", "filters"]);
    let subCategoryIndex = filters.findIndex((filter) => {
      return filter.get("id") === payload.subCategory;
    });
    let isMultiSelectable = filters.getIn([
      subCategoryIndex,
      "isMultiSelectable",
    ]);
    let filterIndex = filters
      .getIn([subCategoryIndex, "values"])
      .findIndex((value) => {
        return value.get("id") === payloadFilter.get("id");
      });
    let filter = state.getIn([
      payload.category,
      "data",
      "filters",
      subCategoryIndex,
      "values",
      filterIndex,
    ]);
    let toggled = filter.get("toggled") ? false : true;
    let newState = state;

    if (!isMultiSelectable) {
      newState = newState.removeIn([
        payload.category,
        "data",
        "enabledFilters",
        subCategoryIndex,
      ]);
      filters.getIn([subCategoryIndex, "values"]).forEach((value, key) => {
        newState = newState.setIn(
          [
            payload.category,
            "data",
            "filters",
            subCategoryIndex,
            "values",
            key,
            "toggled",
          ],
          filterIndex === key ? toggled : false,
        );
      });
    } else {
      newState = state.setIn(
        [
          payload.category,
          "data",
          "filters",
          subCategoryIndex,
          "values",
          filterIndex,
          "toggled",
        ],
        toggled,
      );
    }

    let enableClearAll = false;
    if (toggled) {
      let enabledFilter = payloadFilter.set("toggled", true);
      newState = newState.setIn(
        [
          payload.category,
          "data",
          "enabledFilters",
          subCategoryIndex,
          payloadFilter.get("id"),
        ],
        enabledFilter,
      );
    } else {
      newState = newState.removeIn([
        payload.category,
        "data",
        "enabledFilters",
        subCategoryIndex,
        payloadFilter.get("id"),
      ]);

      if (
        newState.getIn([
          "categories-filters.editorschoice",
          "data",
          "enabledFilters",
          0,
        ]) &&
        newState.getIn([
          "categories-filters.editorschoice",
          "data",
          "enabledFilters",
          0,
        ]).size === 0
      ) {
        newState = newState.removeIn([
          payload.category,
          "data",
          "enabledFilters",
          subCategoryIndex,
        ]);
      }
    }

    newState
      .getIn([payload.category, "data", "filters"])
      .forEach((filter, i) => {
        filter.get("values").forEach((value, j) => {
          let toggled = value.get("toggled") ? true : false;
          if (toggled) {
            enableClearAll = true;
            return;
          }
        });
      });

    newState = newState.setIn(
      [payload.category, "enableClearAll"],
      enableClearAll,
    );
    newState = newState.setIn([payload.route.get("rel"), "isLoading"], true);
    return newState;
  },
  [CategoryTypes.SET_CATEGORY_SORTING](state, { payload }) {
    let newState = state;
    newState = newState.setIn(
      [payload.category, "data", "sortBy"],
      payload.sorting,
    );
    return newState;
  },
  [CategoryTypes.CLEAR_FILTER_BY_CATEGORY](state, { payload }) {
    let filters = state.getIn([payload.category, "data", "filters"]);
    let subCategoryIndex = filters.findIndex((filter) => {
      return filter.get("id") === payload.subCategory;
    });
    let newState = state;
    state
      .getIn([payload.category, "data", "filters", subCategoryIndex, "values"])
      .forEach((value, index) => {
        newState = newState.setIn(
          [
            payload.category,
            "data",
            "filters",
            subCategoryIndex,
            "values",
            index,
            "toggled",
          ],
          false,
        );
      });

    let enableClearAll = false;
    newState
      .getIn([payload.category, "data", "filters"])
      .forEach((filter, i) => {
        filter.get("values").forEach((value, j) => {
          let toggled = value.get("toggled") ? true : false;
          if (toggled) {
            enableClearAll = true;
            return;
          }
        });
      });
    newState = newState.removeIn([
      payload.category,
      "data",
      "enabledFilters",
      subCategoryIndex,
    ]);
    newState = newState.setIn(
      [payload.category, "enableClearAll"],
      enableClearAll,
    );
    newState = newState.setIn([payload.category, "isLoading"], true);
    return newState;
  },
  [CategoryTypes.CLEAR_ALL_FILTERS](state, { payload }) {
    let newState = state;
    let filters = newState.getIn([payload.category, "data", "filters"]);
    filters.forEach((filter, i) => {
      filter.get("values").forEach((value, j) => {
        newState = newState.setIn(
          [payload.category, "data", "filters", i, "search"],
          undefined,
        );
        newState = newState.setIn(
          [payload.category, "data", "filters", i, "values", j, "toggled"],
          false,
        );
      });
    });

    newState = newState.removeIn([payload.category, "data", "enabledFilters"]);
    newState = newState.setIn([payload.category, "enableClearAll"], false);
    newState = newState.setIn([payload.category, "isLoading"], true);
    return newState;
  },
  [CategoryTypes.DELETE_FILTER_CATEGORY](state, { payload }) {
    let newState = state;
    newState = newState.removeIn([payload.category]);
    return newState;
  },
});
